// extracted by css-extract-rspack-plugin
export default {"overflowEllips":"EgovApplicationRow__overflowEllips--fOzkY","errorText":"EgovApplicationRow__errorText--gB7q_"};